import {createContext, useContext, useState} from 'react';
import {Cart} from "contexts/cart/cart.provider";
import {useApolloClient, useQuery} from "@apollo/client";
import gql from "graphql-tag";
import {getAvailableStockQty} from "graphql/queries";
import {CartContext} from "contexts/cart/cart.context";


export const StockItemContext = createContext({} as any);

const key = (id, start, end, location) => [id, start, end, location].join('-');

const StockItemProvider = (props: any) => {
    const client = useApolloClient();
    const [availableQty, setAvailableQty] = useState({});

    async function getAvailableStockQtyReq(productId, start, end, location = null) {
        const {data: {getAvailableStockQty: qty}} = await client.query({
            context: {clientName: 'unauthed'},
            query: gql(getAvailableStockQty),
            variables: {
                input: {
                    company: 'scuttle',
                    products: [productId],
                    startTime: start,
                    endTime: end,
                    location
                }
            }
        });
        return qty[0];
    }


    async function getAvailableQty(productId, startTime, endTime, location = null): Promise<number> {
        const data = await fetch("/rent/api/products/stock", {
            method: "post",
            body: JSON.stringify({
                productId,
                startTime,
                endTime,
                location
            })
        }).then(rsp => rsp.json());

        setAvailableQty((availableQty) => {
            availableQty[key(productId, startTime, endTime, location)] = data.result;
            return availableQty;
        });

        return data.result;
        // if (availableQty[key(productId, start, end, location)]) {
        //     return availableQty[key(productId, start, end, location)];
        // }
        // try {
        //     const qty = await getAvailableStockQtyReq(productId, start, end, location);
        //     const {locationQty} = qty;
        //     const totalQty = locationQty.reduce((acc, curr) => acc + curr.qty, 0);

        //     return totalQty;
        // } catch (e: any) {
        //     console.log(e);
        //     return 0;
        // }
    }

    async function getAvailableQty2(productId, startTime, endTime, location = null): Promise<number> {
        const data = await fetch("/rent/api/products/stock", {
            method: "post",
            body: JSON.stringify({
                productId,
                startTime,
                endTime,
                location
            })
        }).then(rsp => rsp.json());

        return data.result;
    }


    function getCachedAvailableQty(productId, start, end, location = null) {
        return availableQty[key(productId, start, end, location)];
    }

    return (
        <StockItemContext.Provider
            value={{
                getAvailableQty,
                getCachedAvailableQty,
                getAvailableQty2
            }}
        >
            {props.children}
        </StockItemContext.Provider>
    );
};
export default (StockItemProvider);